import { RtbCampaignListBasic } from './RtbCampaign';
import { get } from 'lodash';
import { CreativeOfCampaign } from 'core/creative/Creative';

export type CreativeManagementData = {
  id: number;
  startDate: string;
  endDate: string;
  name: string;
  draftId?: number;
  creatives: CreativeOfCampaign[];
  channel: string;
  channelGroupId?: number;
  // ECOPD-5640：這檔電子紙活動鎖到的門市／機台今天有幾個已被 10 個活動綁滿而排不進去。
  // 語意是「當下」不是「走期內」，理由見 isEpaperSpaceQuotaFull。
  storeOverBindingLimitCount?: number;
};

export type CreativeBindData = {
  id: number;
  startDate: string;
  endDate: string;
  name: string;
  adType?: string;
  adTypeId?: number;
  channel: string;
  channelGroupId?: number;
  draftId?: number;
  billingEvent: string;
  isPmp?: boolean;
  // ECOPD-5640：同上。從活動列表帶進來（那支請求本來就帶 additional_info=limitations）。
  storeOverBindingLimitCount?: number;
};

export function createCreativeBindDataByCampaign(
  campaign: RtbCampaignListBasic,
  channel: string,
  channelGroupId?: number
): CreativeBindData {
  return {
    id: campaign.id,
    startDate: campaign.startDate,
    endDate: campaign.endDate,
    name: campaign.name,
    adType: campaign.adType,
    adTypeId: campaign.adTypeId,
    channel,
    channelGroupId,
    draftId: campaign.draftId,
    billingEvent: 'UNSPECIFIED',
    isPmp: get(campaign, 'additionalInfo.pmp') !== undefined,
    storeOverBindingLimitCount: campaign.storeOverBindingLimitCount
  } as CreativeBindData;
}
